import {auth} from '../../utils/fireStore';
import {signInWithEmailAndPassword} from 'firebase/auth';

export const signIn = async (email: string, password: string) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log(userCredential);
    return userCredential;
  } catch (error) {
    console.log(error);
    return undefined;
  };
};
